export class FacultyFellowshipSpecialisationModel{  
         Id:string
         FacultyId:string;
         FacultyName:string;
         FellowshipSpecialisationName:string;

}